import { envConfigs } from '../../../envConfigs';
import { handleServiceCall } from '../../app/util/fetch-utils';

/*
 new call to prism learner dashboard
 curl --url 'https://prism-dev.dev.rosettastone.com/reports/learner/dashboard/{userId}'

 returns an object like this:

     {
      "allTimeActivities": {
        "elearningTimeSpentMs": 1234,
        "mobileTimeSpentMs": 1234,
        "totalTimeSpentMs": 2134,
        "tutoringTimeSpentMs": 1234
      },
      "isLearner": true,
      "cefrLevel": "B1",
      "languageOfStudy": "en-US",
      "monthToDateActivities": {
        "elearningTimeSpentMs": 1234,
        "mobileTimeSpentMs": 123421,
        "totalTimeSpentMs": 1234,
        "tutoringTimeSpentMs": 12341234
      },
      "name": "lazy daze",
      "organization": "Entropy Light and Sound",
      "ssoCode": "els"
    }

    currently some of the millisecond values are null - maybe a bug in prism?

*/
export const getLearnerDashboard = (userId, token) => {
  // LP dashboard doesn't do anything with lastUsageDate so don't bother querying for it
  const prismUri = envConfigs.prismApiHost + '/reports/learner/dashboard/' + userId + '?skipLastUsageDate=true';

  return Promise.race([
    fetch(prismUri, {
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }),
    // timeout after 10 seconds
    new Promise((_, reject) => setTimeout(() => reject(new Error('timeout')), 10000))
  ])
    .then((response) => {
      return handleServiceCall(response);
    })
    .catch((e) => {
      return false;
    });
};



// WEBPACK FOOTER //
// ./src/modules/launchpad/services/dashboard-api.js